import axios from "axios";
import _ from "lodash";
import { enqueueSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { API } from "../../helpers/constants";
import { handleAxiosErrors } from "../../helpers/errorHandling";
import { GENERAL_SETTINGS } from "../../locales/components/namespaces";
import { mapCoorganizations } from "../../types/coorganizations/map";
import useExhibitionAction from "../exhibitions/useExhibitionAction";
import useExhibitionData from "../exhibitions/useExhibitionData";
import useUserData from "../user/useUserData";

export const useCoorganizations = () => {
    const { t } = useTranslation(GENERAL_SETTINGS)
    const { token } = useUserData()
    const [loading, setLoading] = useState(false)
    const [coorganizations, setCoorganizations] = useState([])
    const [confirmDeleteCoorganization, setConfirmDeleteCoorganization] = useState({
        open: false,
        loading: false,
        id: ''
    })
    const { indexTable: exhibitions } = useExhibitionData()
    const { getExhibitions } = useExhibitionAction()
    
    const getCoorganizations = useCallback(() => {
        setLoading(true)
        axios({
            method: 'get',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/en/coorganization/list`
        }).then((response) => {
            if(response.data && response.data.length > 0) {
                setCoorganizations(response.data.map(i => mapCoorganizations(i)))
            }
        }).catch((error) => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error), {
                variant: 'error',
                autoHideDuration: null,
            })
        })
        setLoading(false)
    }, [token])
    
    useEffect(() => {
        getCoorganizations()
    }, [getCoorganizations])
    
    const deleteCoorganization = useCallback((id) => {
        setConfirmDeleteCoorganization(old => ({
            ...old,
            loading: true
        }))
        axios({
            method: 'post',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/en/coorganization/delete/${id}`
        }).then(() => {
            enqueueSnackbar(t('Coorganization removed successfully!'), {
                variant: 'success'
            })
            setConfirmDeleteCoorganization(old => ({
                open: false,
                loading: false,
                id: ''
            }))
            getCoorganizations()
        }).catch((error) => {
            setConfirmDeleteCoorganization(old => ({
                ...old,
                loading: false,
            }))
            enqueueSnackbar(handleAxiosErrors(error), {
                variant: 'error',
                autoHideDuration: null,
            })
        })
        setLoading(false)
    }, [getCoorganizations, t, token])

    return {
        coorganizations: _.orderBy(coorganizations, ['orderById'], ['desc']),
        loading,
        getCoorganizations,
        getExhibitions,
        exhibitions: exhibitions.items,
        exhibitionsLoading: exhibitions.loading,
        deleteCoorganization,
        confirmDeleteCoorganization,
        setConfirmDeleteCoorganization,
    }
}